// Page header for the facilities view, same layout as the retail, concessions and gates headers,
// with the restrooms' images stacked like the gate icons, and the Overview / Game Day tabs.
import React, { useContext } from 'react';
import SportIcon from '../../../components/atoms/SportIcon';
import Icon from '../../../components/atoms/Icon';
import { ThemeContext } from '../../../components/molecules/Nav';
import RestroomIcon from './RestroomIcon';
import '../../Concession/concession.css';
import '../../Gates/gates.css';
import '../facilities.css';

const FacilitiesHeader = ({ currentLocation, isToday, selectedDate, dayType, setDayType, loading }) => {
  const [theme] = useContext(ThemeContext);
  const name = currentLocation?.name || 'Restrooms';
  const logo = theme === 'light' ? currentLocation?.logoPath : currentLocation?.logoPathDark || currentLocation?.logoPath;
  // The eyebrow names the vertical; skip it when the location is itself called "Facilities"
  const withImages = (currentLocation?.restrooms || []).filter((r) => r.imageURL);
  const showEyebrow = name.trim().toLowerCase() !== 'facilities';

  return (
    <div className="cx-header">
      <div className="cx-header-identity">
        {/* The restrooms' own images, overlapping, in place of a logo (like the gates header).
            Any number of restrooms: the overlap tightens to fit, and the last image always shows in full.
            Falls back to the location logo when no restroom has an image. */}
        {withImages.length > 0 ? (
          <>
            <div className="gx-hstack" aria-hidden="true">
              {withImages.map((r) => (
                <span className="gx-hstack-slot" key={r.restroomId}>
                  <RestroomIcon imageURL={r.imageURL} className="fx-hstack-icon" />
                </span>
              ))}
            </div>
            <div className="cx-header-divider" />
          </>
        ) : logo && (
          <>
            <img className="cx-header-logo" src={require(`../../../clients/${logo}`)} alt="logo" />
            <div className="cx-header-divider" />
          </>
        )}
        <div style={{ minWidth: 0 }}>
          {showEyebrow && <div className="cx-eyebrow">Facilities</div>}
          <h1 className="cx-header-title">{name}</h1>
        </div>
      </div>

      <div className="cx-header-actions">
        {dayType === 'game' && isToday && selectedDate && (
          <span className="cx-live-pill">
            <span className="pulsing-dot" />
            Live
          </span>
        )}
        <div className="cx-segmented" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={dayType === 'overview'}
            disabled={loading}
            onClick={() => setDayType('overview')}
            className={`cx-segmented-btn ${dayType === 'overview' ? 'active' : ''}`}
          >
            <Icon name="graph-up" />
            Overview
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={dayType === 'game'}
            disabled={loading}
            onClick={() => setDayType('game')}
            className={`cx-segmented-btn ${dayType === 'game' ? 'active' : ''}`}
          >
            <SportIcon fontSize="inherit" />
            Game Day
          </button>
        </div>
      </div>
    </div>
  );
};

export default FacilitiesHeader;
